import { ValidationProvider, ValidationObserver } from 'vee-validate';
import mixins from 'vue-typed-mixins';
import changePersonalEmailMixin from './changePersonalEmailMixin';
import { faqMixin } from '@/mixins';
import { Collapsible, Card, TextField, Button, Icon, Alert as VAlert, Accordion, } from '@/components';
const ValidationError = () => import('@/components/ValidationError.vue');
const CardHeader = () => import('./CardHeader.vue');
const CardStep = () => import('./CardStep.vue');
export default mixins(changePersonalEmailMixin, faqMixin).extend({
    components: {
        Card,
        TextField,
        Accordion,
        Icon,
        Button,
        CardHeader,
        CardStep,
        ValidationProvider,
        ValidationObserver,
        ValidationError,
        VAlert,
        Collapsible,
    },
    props: {
        alert: {
            type: Object,
            default: () => ({
                message: '',
                type: '',
            }),
        },
        email: {
            type: String,
            default: '',
        },
        submittingEmail: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        personalEmail: '',
        isEmailReadonly: true,
    }),
    computed: {
        forgotPasswordContent() {
            return `Untuk mendapatkan password Akun Pembelajaran yang baru, kamu bisa
            menghubungi Operator Sekolah (Admin Sekolah) atau silakan
            menghubungi Unit Layanan Terpadu (ULT) di tautan
            http://ult.kemdikbud.go.id/.`;
        },
        faq() {
            return this.faqItems[0];
        },
        faqQuestion() {
            var _a;
            return (_a = this.faq) === null || _a === void 0 ? void 0 : _a.a;
        },
        faqAnswer() {
            var _a;
            return (_a = this.faq) === null || _a === void 0 ? void 0 : _a.a;
        },
    },
    watch: {
        email: {
            immediate: true,
            handler(val) {
                this.personalEmail = val;
            },
        },
        submittingEmail(val) {
            if (val) {
                setTimeout(() => {
                    this.$emit('alert:hide');
                }, 30 * 1000);
            }
        },
    },
    methods: {
        enableInnerEmail() {
            var _a;
            if (this.personalEmail === this.email) {
                this.isEmailReadonly = false;
                (_a = this.$refs.inputEmail) === null || _a === void 0 ? void 0 : _a.focus();
            }
        },
        async onEmailBlur() {
            const emailRef = this.$refs.emailRef;
            const status = await emailRef.validate();
            const isEmailNotChanged = this.personalEmail === this.email;
            if (status.valid && !isEmailNotChanged) {
                this.changePersonalEmail(this.personalEmail);
            }
        },
        sendDetailToEmail() {
            this.$emit('sendDetail');
        },
    },
});
